export default "__VITE_ASSET__814cc239__"